import { DEFAULT_FACTURATION_CONFIG } from '../facturationConfigDefaults';

/** @deprecated Prefer resolveFacturationPageSize / getFacturationItemsPerPage from config. */
export const FACTURATION_TABLE_PAGE_SIZE = DEFAULT_FACTURATION_CONFIG.itemsPerPage;

/** Resolve page size from module config object or settings snapshot. */
export function resolveFacturationPageSize(configOrSettings) {
  const fromConfig = configOrSettings?.itemsPerPage;
  if (fromConfig != null) {
    const n = Number(fromConfig);
    if ([25, 50, 100].includes(n)) return n;
  }
  const fromSettings = configOrSettings?.facturation?.itemsPerPage;
  if (fromSettings != null) {
    const n = Number(fromSettings);
    if ([25, 50, 100].includes(n)) return n;
  }
  return DEFAULT_FACTURATION_CONFIG.itemsPerPage;
}

export function facturationClampPage(rawPage, totalItems, pageSize = FACTURATION_TABLE_PAGE_SIZE) {
  const tp = Math.max(1, Math.ceil(Math.max(0, totalItems) / pageSize));
  return Math.min(Math.max(1, rawPage), tp);
}

export function facturationPagedSlice(items, rawPage, pageSize = FACTURATION_TABLE_PAGE_SIZE) {
  const list = Array.isArray(items) ? items : [];
  const page = facturationClampPage(rawPage, list.length, pageSize);
  const start = (page - 1) * pageSize;
  return list.slice(start, start + pageSize);
}

